import Vue from 'vue';
import InvoiceInfoCard from './cards/info/InvoiceInfoCard';
import InvoiceSpecialNotes from './cards/special/InvoiceSpecialNotesCard';
import InvoiceFacilityBillable from './cards/billable/InvoiceFacilityBillable';
import InvoiceProviderPayable from './cards/payable/InvoiceProviderPayable';
import { UserRoleEnum } from '@/enums/userRolesEnum';
import { InvoiceStatus, ColorClass } from '@/enums/invoiceStatusEnum';
import {AppEntityType} from '@/enums/AppEntityType';
import NotesCard from '../../componentsReusable/cards/NotesCard';
import AttachmentsCard from '../../componentsReusable/cards/AttachmentsCard';
import InvoiceChecklistCard from './cards/checklist/InvoiceChecklistCard';
import PotentialInvoiceDetailsCard from './cards/potentialDetails/PotentialInvoiceDetailsCard';
import PotentialInvoiceTotalsCard from './cards/potentialTotals/PotentialInvoiceTotalsCard';
import InvoiceListItems from "@/components/invoice/cards/lineItems/InvoiceLineItems";
import HttpMixin from "@/mixins/HttpMixin";
import GenericModal from '@/componentsReusable/genericModal.vue';
import {HTTP} from "@/utils/httpCommonUtil";
import {getRestResponseErrorMessage} from "@/utils/serverErrorMessageUtil";

export default Vue.extend({
  name: 'Invoice',
  props: {
    'invoiceId': { type: [String, Number] }
  },
  mixins: [HttpMixin],
  components: {
    InvoiceFacilityBillable,
    InvoiceListItems,
    InvoiceProviderPayable,
    InvoiceInfoCard,
    NotesCard,
    AttachmentsCard,
    InvoiceSpecialNotes,
    InvoiceChecklistCard,
    PotentialInvoiceDetailsCard,
    PotentialInvoiceTotalsCard,
    GenericModal
  },
  data () {
    return {
      invoiceInfo: null as any,
      noteEntityType: AppEntityType.INVOICE_NOTE,
      attachmentEntityType: AppEntityType.INVOICE_ATTACHMENT,
      showSaveTemplateModal: false,
      templateName: ''
    };
  },
  computed: {
    statusClassObject (): string {
      if (!this.invoiceInfo) {
        return ColorClass.RED;
      }
      switch (this.invoiceInfo.invoiceStatusId) {
        case InvoiceStatus.SUBMITTED:
          return ColorClass.BLUE;
        case InvoiceStatus.PARTIALLY_PAID:
          return ColorClass.YELLOW;
        case InvoiceStatus.FULLY_PAID:
          return ColorClass.GREEN;
        default:
          return ColorClass.RED;
      }
    },
    facilityPortalStatusClassObject (): string {
      if (!this.invoiceInfo) {
        return ColorClass.YELLOW;
      } else if (this.isFullyPaid) {
        return ColorClass.GREEN;
      } else if (this.invoiceInfo.isPastDue) {
        return ColorClass.RED;
      }
      return ColorClass.YELLOW;
    },
    isFacilityUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.FACILITY_CONTACT);
    },
    isAuthorized (): boolean {
      return this.$store.getters['user/hasRole']([
        UserRoleEnum.MANAGER,
        UserRoleEnum.ACCOUNTANT,
        UserRoleEnum.FACILITY_CONTACT
      ]);
    },
    isFullyPaid (): boolean {
      return this.invoiceInfo && this.invoiceInfo.invoiceStatusId === InvoiceStatus.FULLY_PAID;
    },

  },
  methods: {
    invoiceInfoLoaded (invoiceInfo: any) {
      this.invoiceInfo = invoiceInfo;
    },
    async saveTemplate() {
      try {
        await HTTP.post(`api/special-invoice-templates`, {
          invoiceId: this.invoiceId,
          templateName: this.templateName
        });

        this.templateName = '';
        this.showSaveTemplateModal = false;
      } catch (err) {
        let generalError = getRestResponseErrorMessage(err);
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Creating Template',
          text: generalError ? generalError : 'An error occurred creating the special invoice template.',
          // duration: 5000
        });
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/invoice/Invoice.ts